import { render, staticRenderFns } from "./orderSearchDetail.vue?vue&type=template&id=d2a01048&scoped=true&"
import script from "./orderSearchDetail.vue?vue&type=script&lang=js&"
export * from "./orderSearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderSearchDetail.vue?vue&type=style&index=0&id=d2a01048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a01048",
  null
  
)

export default component.exports